<div class="container mx-auto p-6 font-raleway">
  <h1 class="text-4xl lg:text-6xl font-extrabold font-alice mb-8">Ressources</h1>

  <mat-form-field class="w-full">
    <mat-label>Filtrer</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Bourrée" #input>
  </mat-form-field>

  <!-- Grid de cartes responsive -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    @for (ressource of filteredRessources; track ressource) {
      <div
        class="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 cursor-pointer"
        (click)="viewDetails(ressource.key)">
        <div class="flex items-center gap-4">
          <!-- Icône basée sur le type -->
          <div class="flex-shrink-0">
            <mat-icon class="text-2xl text-gray-600">
              @switch (ressource.type) {
                @case ('DANSE') {
                  directions_run
                }
                @case ('MUSIQUE') {
                  music_note
                }
                @case ('CHANT') {
                  mic
                }
                @case ('SPECTACLE') {
                  theater_comedy
                }
                @default {
                  description
                }
              }
            </mat-icon>
          </div>
          <div class="flex-grow">
            <h3 class="text-lg font-semibold text-gray-800 hover:text-blue-600">{{ressource.nom}}</h3>
            <p class="text-sm text-gray-600">{{ressource.type}}</p>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Message quand aucune donnée -->
  @if (filteredRessources.length === 0) {
    <div class="text-center py-8">
      @if (input.value) {
        <div>
          Aucune ressource ne correspond au filtre "{{input.value}}"
        </div>
      } @else {
        Aucune ressource disponible
      }
    </div>
  }
</div>